import { LayoutComponent } from './layouts/layout/layout.component';
import { VexRoutes } from '@vex/interfaces/vex-route.interface';
import { content, landing } from './shared/routes/routes';
import { LoginComponent } from './auth/login/login.component';
import { GettingStarted } from './getting-started/getting-started';
import {AboutUsComponent} from "./landing/pages-list/about-us/about-us.component";
import {FeaturesComponent} from "./landing/pages-list/features/features.component";
import {PricingAndPlansComponent} from "./landing/pages-list/pricing-and-plans/pricing-and-plans.component";
import {HelpAndSupportComponent} from "./landing/pages-list/help-and-support/help-and-support.component";
import {ContactUsComponent} from "./landing/pages-list/contact-us/contact-us.component";
import {AddOrgComponent} from "./landing/pages-list/add-org/add-org.component";
import {
  OrganizationRegisterComponent
} from "./landing/pages-list/organization-register/organization-register.component";
import {CheckOutComponent} from "./landing/pages-list/check-out/check-out.component";
import {TermsConditionsComponent} from "./landing/pages-list/terms-conditions/terms-conditions.component";
import {PaymentSuccessComponent} from "./landing/pages-list/payment/payment-success/payment-success.component";
import {PaymentFailedComponent} from "./landing/pages-list/payment/payment-failed/payment-failed.component";
import {RefundPolicyComponent} from "./landing/pages-list/refund-policy/refund-policy.component";
import {BlogsComponent} from "./landing/pages-list/blogs/blogs.component";
import {BlogDetailsComponent} from "./landing/pages-list/blog-details/blog-details.component";
import {OurServicesComponent} from "./landing/pages-list/our-services/our-services.component";
import {VerifyOtpComponent} from "./auth/verify-otp/verify-otp.component";
export const appRoutes: VexRoutes = [
  {
    path: '',
    component: LayoutComponent,
    children: content
  },
  {
    path: 'auth/login',
    component: LoginComponent
  },
  {
    path: 'auth/verify-otp',
    component: VerifyOtpComponent
  },
  {
    path: 'about-us',
    component: AboutUsComponent,
    children: landing
  },
  {
    path: 'our-services',
    component: OurServicesComponent,
    children: landing
  },
  {
    path: 'features',
    component: FeaturesComponent,
    children: landing
  },
  {
    path: 'pricing-plans',
    component: PricingAndPlansComponent,
    children: landing
  },
  {
    path: 'help-and-support',
    component: HelpAndSupportComponent,
    children: landing
  },
  {
    path: 'contact-us',
    component: ContactUsComponent,
    children: landing
  },
  {
    path: 'add-org',
    component: AddOrgComponent,
    children: landing
  },
  {
    path: 'auth/register',
    component: OrganizationRegisterComponent,
    children: landing
  },
  {
    path: 'getting-started',
    component: GettingStarted
  }
  ,
  {
    path: 'checkout/:id',
    component: CheckOutComponent
  },
  {
    path: 'terms-conditions',
    component: TermsConditionsComponent,
    children: landing
  },
  {
    path: 'order/:id',
    component: PaymentSuccessComponent
  },
  {
    path: 'order-failed',
    component: PaymentFailedComponent
  },
  {
    path: 'refund-policy',
    component: RefundPolicyComponent
  },
  {
    path: 'blogs',
    component: BlogsComponent
  },
  {
    path: 'blog-details',
    component: BlogDetailsComponent
  }
];



